import React from "react";

const Button = () => {
  return <div>Testing Button</div>;
};

export default Button;
